export default {
    "apiGateway": {
        "ADDRESS": "https://735xzp3zv3.execute-api.us-east-1.amazonaws.com",
        "STAGE": "prod"
    },
    "services": {
        "PRODUCTS": "products",
        "CART": "cart",
        "CHECKOUT": "checkout"
    },
    "cognito": {
        "USER_POOL_ID": "us-east-1_wHw1xeEmw",
        "APP_CLIENT_ID": "1mvfiab7rknv5n9ui588jsva5t",
        "IDENTITY_POOL_ID": "us-east-1:d0b7f77e-58bc-4650-9e7c-2615360dbc64",
        "REGION": "us-east-1"
    },
    "iot": {
        "ENDPOINT": "aghmdogbzjnwu-ats.iot.us-east-1.amazonaws.com",
        "REGION": "us-east-1",
        "topics": {
            "COMMENTS": "serverless-store-comments"
        },
        "POLICY_NAME": "iot-policy"
    }
}


// WEBPACK FOOTER //
// ./src/lib/config.js